<template>
  <div>
  </div>
</template>

<script>
import report from '@/modules/report'
export default {
  name: 'R000001',
  mixins: [report],
  created () {
    this.moveReportPage('B')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/R000001.vue